// extracted by mini-css-extract-plugin
export default {"body":"AdminSearchBar_body__9OGAw","searchBar":"AdminSearchBar_searchBar__VnZXd","searchIcon":"AdminSearchBar_searchIcon__loOyk"};